import React from 'react';
import {
  Instagram as InstagramIcon,
  Facebook as FacebookIcon,
  ChatBubbleOutline as MessengerIcon,
} from '@mui/icons-material';
import { T, fontBody } from '../tokens';
import StatusPill from '../StatusPill';
import TemplateCardMenu from './TemplateCardMenu';

const CHANNEL_ICON_MAP = {
  instagram_comment: { Icon: InstagramIcon, color: '#E1306C', bg: '#FFF0F5' },
  instagram_dm:      { Icon: InstagramIcon, color: '#833AB4', bg: '#F5F0FF' },
  facebook_comment:  { Icon: FacebookIcon,  color: '#1877F2', bg: '#EFF5FF' },
  facebook_messenger:{ Icon: MessengerIcon, color: '#0084FF', bg: '#EFF8FF' },
};

function resolveChannelMeta(template) {
  const ch = template.triggerChannel;
  if (ch && CHANNEL_ICON_MAP[ch]) return CHANNEL_ICON_MAP[ch];
  const fallback = {
    comment_reply: CHANNEL_ICON_MAP.instagram_comment,
    comment_dm:    CHANNEL_ICON_MAP.instagram_comment,
    dm_reply:      CHANNEL_ICON_MAP.instagram_dm,
  };
  return fallback[template.templateType] || null;
}

function ChannelIcon({ meta }) {
  const { Icon, color, bg } = meta;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: 28, height: 28, borderRadius: 8,
      background: bg,
      border: `1.5px solid ${color}30`,
      boxShadow: `0 0 0 3px ${color}12`,
      flexShrink: 0,
    }}
    >
      <Icon sx={{ fontSize: 15, color }} />
    </span>
  );
}

function DefaultBadge() {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: '3px 8px', borderRadius: 999,
      background: '#F0FDF4', border: '1px solid #BBF7D0',
      fontFamily: fontBody, fontSize: 11, fontWeight: 700,
      color: '#15803D', letterSpacing: '0.03em',
      flexShrink: 0,
    }}
    >
      DEFAULT
    </span>
  );
}

export default function TemplateCardHeader({ template, onToggleStatus, onDelete, toggling }) {
  const channelMeta = resolveChannelMeta(template);

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
      {/* Channel icon + name block */}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, minWidth: 0, flex: 1, overflow: 'hidden' }}>
        {channelMeta && <ChannelIcon meta={channelMeta} />}
        <div style={{ minWidth: 0, overflow: 'hidden' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
            <span style={{
              fontFamily: fontBody, fontSize: 15, fontWeight: 700, color: T.ink, lineHeight: 1.3,
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '100%',
            }}>
              {template.name}
            </span>
            {(template.isSystemDefault || template.isChannelDefault) && <DefaultBadge />}
          </div>
          <div style={{
            fontFamily: fontBody, fontSize: 12.5, color: T.slate, marginTop: 2,
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }}>
            {template.trigger}
          </div>
        </div>
      </div>

      {/* Status + menu */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
        <StatusPill status={template.status} />
        <TemplateCardMenu
          template={template}
          onToggleStatus={onToggleStatus}
          onDelete={onDelete}
          toggling={toggling}
        />
      </div>
    </div>
  );
}
